import React from 'react';
import { SDS_SIZE_BORDER_MEDIUM, SDS_SIZE_BORDER_SMALL, SDS_SIZE_BORDER_LARGE } from '@s-group/design-system-tokens/web/tokens/size.es6.js';
import '../CheckableBase/CheckableBase.js';
import { indicatorSize } from '../CheckableBase/constants.js';
import { pxValue } from '../common/util.js';
import { useMediaQuery } from '../common/hooks.js';
import { scaleSVGPath } from './util.js';

const Indicator = ({ sizing, ...rest }) => {
    // Border rectangle defines the visible outer edge ot the indicator in
    // the default (unfocused) state.
    const borderDimension = indicatorSize[sizing];
    const borderWidth = useMediaQuery('(min-resolution: 150dpi)')
        ? pxValue(SDS_SIZE_BORDER_MEDIUM)
        : pxValue(SDS_SIZE_BORDER_SMALL);
    const borderRadius = borderWidth;
    // Focus outline is always 2 CSS pixels larger than the border rectangle
    const focusOutlineWidth = pxValue(SDS_SIZE_BORDER_LARGE);
    const focusDimension = borderDimension + 2 * focusOutlineWidth;
    const focusPosition = 0;
    const focusRadius = borderRadius + focusOutlineWidth;
    const borderPosition = focusOutlineWidth;
    // Background rectangle doesn't scale proportionally, it is always
    // border width smaller than the border rectangle.
    const backgroundDimension = borderDimension - 2 * borderWidth;
    const backgroundPosition = borderPosition + borderWidth;
    // View box dimensions are the same as the focus outline dimensions
    const viewBoxDimension = focusDimension;
    const indicatorBaseSize = indicatorSize['small'];
    const scaleFactor = indicatorSize[sizing] / indicatorBaseSize;
    const viewBoxCenter = viewBoxDimension / 2;
    const moveToCenter = `M${viewBoxCenter},${viewBoxCenter}`;
    // In order to positioning and scaling to work properly, SVG paths are
    // expected to contain only relative line commands around the center point
    // of the graphic.
    //
    // The original paths are exported from Figma in the indicator base size
    // used in scaling (16px) and then converted to relative coordinates.
    const checkmarkPath = moveToCenter +
        scaleSVGPath('m-0.97,0.939l4.47,-4.47l1.06,1.061l-5.53,5.53l-3.03,-3.03l1.06,-1.061l1.97,1.97z', scaleFactor);
    const indeterminatePath = moveToCenter + scaleSVGPath('m4,1h-8v-1.5h8v1.5z', scaleFactor);
    return (React.createElement("svg", { ...rest, height: viewBoxDimension, viewBox: `0 0 ${viewBoxDimension} ${viewBoxDimension}`, width: viewBoxDimension, xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("rect", { className: "focus", x: focusPosition, y: focusPosition, rx: focusRadius, ry: focusRadius, width: focusDimension, height: focusDimension }),
        React.createElement("rect", { className: "border", x: borderPosition, y: borderPosition, rx: borderRadius, ry: borderRadius, width: borderDimension, height: borderDimension }),
        React.createElement("rect", { className: "background", x: backgroundPosition, y: backgroundPosition, width: backgroundDimension, height: backgroundDimension }),
        React.createElement("path", { className: "toggle", d: checkmarkPath }),
        React.createElement("path", { className: "indeterminate", d: indeterminatePath })));
};

export { Indicator };
//# sourceMappingURL=CheckboxIndicator.js.map
